import {
  SEND_OTP,
  SEND_OTP_SUCCESS,
  SEND_OTP_FAILURE,
  VERIFY_OTP,
  VERIFY_OTP_SUCCESS,
  VERIFY_OTP_FAILURE,
  RESET_VERIFY_OTP_STATE,
  RESET_LOGIN_STATE,
} from "./loginTypes";

const initialState = {
  mobileNumber: "",
  sendOtp: {
    sendOtpSuccess: false,
    error: "",
  },
  verifyOtp: {
    verifyOtpSuccess: false,
    error: "",
  },
};

const loginReducer = (state = initialState, action) => {
  switch (action.type) {
    case SEND_OTP:
      return {
        ...state,
        mobileNumber: action.payload,
      };
    case SEND_OTP_SUCCESS:
      return {
        ...state,
        sendOtp: { sendOtpSuccess: true },
      };
    case SEND_OTP_FAILURE:
      return {
        ...state,
        sendOtp: { error: action.payload },
      };
    case VERIFY_OTP:
      return {
        ...state,
      };
    case VERIFY_OTP_SUCCESS:
      return {
        ...state,
        verifyOtp: { verifyOtpSuccess: true },
      };
    case VERIFY_OTP_FAILURE:
      return {
        ...state,
        verifyOtp: { error: action.payload },
      };
    case RESET_VERIFY_OTP_STATE:
      return {
        ...state,
        verifyOtp: {
          error: "",
        },
      };
    case RESET_LOGIN_STATE:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default loginReducer;
